import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
  FormArray,
  FormGroup,
  FormControl,
  FormBuilder,
  Validators
} from "@angular/forms";
import { ToastService } from "ng-uikit-pro-standard";
import { SharedDataService } from "src/app/shared-data.service";
import { DataService } from "./../../data.service";
import { GUID } from "./../../guid";
import { AppConfig } from "./../../config";
import { MatTableDataSource, MatSort, MatPaginator } from "@angular/material";
import { eventId } from "src/app/eventid";
import { getRequestID } from "src/app/requestid";

@Component({
  selector: "app-recordtypenew",
  templateUrl: "./recordtypenew.component.html",
  styleUrls: ["./recordtypenew.component.scss"]
})
export class RecordTypeNewComponent implements OnInit {
  @Output() RecordtypeEvent = new EventEmitter<any>();

  // @Input() detailForm: FormGroup;
  // detailForms: FormGroup;
  layout: Array<any>;
  isAllProfileSelect = false;

  recordTypeLayoutId = "";
  metaProfileLayoutWebId = "";
  recordTypeProfileId = "";
  process: Array<any>;
  recordType: any;
  isLoading = false;
  isError = false;
  errorMessage = "";
  recordTypeId = "";
  recordTypeName = "";
  metaobjectId = "";
  metaobjectName = "";
  metalayoutList = [];
  profiles = [];
  layoutProfile = [];
  name = "";
  displayname = "";
  description = "";
  recordtypeProfile: any[] = [];
  sharedDetailForm: FormGroup;
  commonLayout = [];

  mode = "New";
  guid: GUID;

  displayedColumns: string[] = [
    "profile",
    "recordtype",
    "makeavailable",
    "makedefault",
    "masterCheckbox"
  ];
  dataSource = new MatTableDataSource<any>();

  detailForm = this.fb.group({
    metaobjectid: "",
    id: "",
    displayname: "",
    name: "",
    description: "",
    process: "",
    processname: "",
    processid: "",
    profile: "",
    active: true
  });

  detailForms = this.fb.group({
    profilename: "",
    profileid: "",
    makeavailable: false,
    makedefault: false
  });
  oneLayoutId: any;
  oneLayoutName: any;

  constructor(
    private route: ActivatedRoute,
    private sharedDataService: SharedDataService,
    private router: Router,
    private fb: FormBuilder,
    private appConfig: AppConfig,
    private dataService: DataService,
    private toastrService: ToastService
  ) {
    this.sharedDetailForm = this.fb.group({
      metaobjectid: "",
      id: "",
      displayname: "",
      name: "",
      description: "",
      layout: [""],
      layoutname: "",
      layoutid: "",
      profilename: "",
      active: true
    });
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.mode = this.route.snapshot.params.mode;
      this.recordTypeId = this.route.snapshot.params.id;
      this.recordTypeName = this.route.snapshot.params.name;
      this.metaobjectId = this.route.snapshot.params.metaobjectid;
      this.metaobjectName = this.route.snapshot.params.metaobjectname;
      // this.id = this.route.snapshot.params.id;
    });
    // this.detailForms.get('makedefault').disable();

    this.guid = new GUID();
    console.log("mode", this.mode);

    this.getMetalayout();
    this.getActiveProfiles();

    this.getActiveProcess().then((res) => {
      if (this.mode.toLowerCase() == "edit") {
        this.getRecordTypeById();
      }
    });

    this.detailForm.get("name").valueChanges.subscribe((name) => {
      console.log("Name changed:", name);
      this.name = name;
    });

    // Listen for changes in the "Display Name" input
    this.detailForm.get("displayname").valueChanges.subscribe((displayName) => {
      console.log("Display Name changed:", displayName);
      this.displayname = displayName;
    });
    this.detailForm.get("description").valueChanges.subscribe((description) => {
      console.log("description changed:", description);
      this.description = description;
    });
    console.log(this.profiles);
  }
  isAllMakeAvailableChecked(): boolean {
    return this.dataSource &&
      this.dataSource.data &&
      this.dataSource.data.length > 0
      ? this.dataSource.data.every((element) => element.makeavailable)
      : false;
  }

  toggleAllMakeAvailable(checked: boolean): void {
    if (this.dataSource && this.dataSource.data) {
      this.dataSource.data.forEach((element) => {
        element.makeavailable = checked;
      });
    }
  }

  initializeRecordTypeProfiles(profiles: any[]) {
    console.log("initializeRecordTypeProfiles", profiles);
    this.recordtypeProfile = profiles.map((profile) => ({
      makeavailable: this.detailForms.get("makeavailable").value || false,
      makedefault: this.detailForms.get("makedefault").value || false,
      profilename: profile.name,
      profileid: profile.id
    }));
  }

  fieldTypeChange(event, profilename, profileid) {
    console.log("fieldTypeChange", event);
    console.log("fieldTypeChange", profilename);

    console.log("fieldTypeChange", profileid);

    const form = this.detailForms;
    console.log(form);
    const defaultMakeAvailable = form.get("makeavailable").value;
    const defaultMakeDefault = form.get("makedefault").value;

    const formChanges = {
      makeavailable: form.value.makeavailable,
      makedefault: form.value.makedefault,
      profilename: profilename,
      profileid: profileid
    };
    const existingIndex = this.recordtypeProfile.findIndex(
      (change) => change.profileid === profileid
    );

    if (existingIndex !== -1) {
      this.recordtypeProfile[existingIndex] = formChanges;
    } else {
      this.recordtypeProfile.push(formChanges);
    }
    console.log(form);
    console.log(this.recordtypeProfile);

    var arrayControl = event.element.checked;
    console.log(arrayControl);

    // if (!arrayControl&& profilename) {
    //   this.detailForms.get('makedefault').disable();
    // } else {
    //   this.detailForms.get('makedefault').enable();
    // }
  }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Application Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark"
    };
    this.toastrService.warning(data, "", options);
  }

  metaobjectDetail() {
    this.router.navigateByUrl(
      "home/metaobjectdetail/" + this.metaobjectId + "/" + this.metaobjectName
    );
  }

  processChange(event: { value: string; label: any }) {
    console.log("processChange", event);
    if (event.value.trim() != "") {
      this.detailForm.controls["processid"].setValue(event.value);
      this.detailForm.controls["processname"].setValue(event.label);
    } else {
      this.detailForm.controls["processid"].setValue("");
      this.detailForm.controls["processname"].setValue("");
    }
  }

  layoutChange(event) {
    console.log("layoutChange", event);
    this.oneLayoutId = event.value;
    this.oneLayoutName = event.source.triggerValue;

    const form = this.detailForm;

    const formChanges = {
      layoutname: event.label,
      layoutid: event.value
    };

    // const existingIndex = this.storedFormChanges.findIndex(
    //   (change) => change.profileid === profileid
    // );

    // if (existingIndex !== -1) {
    //   // Update the existing entry
    //   this.storedFormChanges[existingIndex] = formChanges;
    // } else {
    //   // Add the changes to the array
    //   this.storedFormChanges.push(formChanges);
    // }
    // if (event.value.trim() !== "") {
    //   form.controls["layoutname"].setValue(event.label);
    //   form.controls["layoutid"].setValue(event.value);
    //   form.controls["profilename"].setValue(profilename);
    //   form.controls["profileid"].setValue(profileid);
    // } else {
    //   form.controls["layoutname"].setValue("");
    //   form.controls["layoutid"].setValue("");
    //   form.controls["profilename"].setValue("");
    //   form.controls["profileid"].setValue("");
    // }
    // this.storedFormChanges.push(formChanges);

    console.log(form);
    console.log(this.commonLayout);
  }

  defaultlayoutChange(event: { value: string; label: any }, profilename: any) {
    console.log("layoutChange", event);
    console.log("name", profilename);

    const form = this.sharedDetailForm;
    if (event.value.trim() !== "") {
      form.controls["layoutname"].setValue(event.label);
      form.controls["layoutid"].setValue(event.value);
      form.controls["profilename"].setValue(profilename);
    } else {
      form.controls["layoutname"].setValue("");
      form.controls["layoutid"].setValue("");
      form.controls["profilename"].setValue("");
    }
    console.log(form);
  }

  getActiveProcess() {
    return new Promise((resolve, reject) => {
      console.log("ProcessFields");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          process: {
            active: "active"
          }
        }
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      this.dataService.getActiveProcess(postOption).subscribe(
        (res) => {
          console.log("res", res);

          if (res !== null && res.success == 1) {
            var activeProcess = res.data.process;
            var proArr = [];
            //just add an empty entry sice this field is optional
            proArr.push({ value: "", label: "--None--" });
            for (let i = 0; i < activeProcess.length; i++) {
              proArr.push({
                value: activeProcess[i].id,
                label: activeProcess[i].name
              });
            }
            this.process = proArr;
            console.log(proArr);

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No process data!");
            this.errorMessage = res != null ? res.message : "No process data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  getActiveProfiles() {
    return new Promise((resolve, reject) => {
      console.log("getActiveProfiles");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          profile: {
            userlicense: localStorage.getItem("crm_userlicense")
          }
        }
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      this.dataService.getActiveProfileByUserLicense(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            this.profiles = res.data.profiles;
            this.dataSource.data = this.profiles;

            console.log("profiles", this.profiles);
            this.initializeRecordTypeProfiles(this.profiles);

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No profile data!");
            this.errorMessage = res != null ? res.message : "No profile data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  getRecordTypeById() {
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      // domain: localStorage.getItem("domain"),
      // subdomain: localStorage.getItem("subdomain"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      data: {
        recordtype: {
          id: this.recordTypeId
        }
      }
    };

    this.isLoading = true;
    this.dataService.getRecordTypeById(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.recordType = res.data.recordtype;
          if (this.recordType != null) {
            this.metaobjectId = this.recordType.metaobjectid;

            this.detailForm.controls["metaobjectid"].setValue(
              this.recordType.metaobjectid
            );
            this.detailForm.controls["id"].setValue(this.recordType.id);
            this.detailForm.controls["displayname"].setValue(
              this.recordType.displayname
            );
            this.detailForm.controls["name"].setValue(this.recordType.name);
            this.detailForm.controls["description"].setValue(
              this.recordType.description
            );
            this.detailForm.controls["processname"].setValue(
              this.recordType.processname
            );
            this.detailForm.controls["processid"].setValue(
              this.recordType.processid
            );
            this.detailForm.controls["process"].setValue(
              this.recordType.processid
            );
            // this.detailForm.controls.parentobject.patchValue(this.recordType.process);
          }

          if (this.recordType != null) {
            this.sharedDetailForm.controls["layoutid"].setValue(
              this.recordType.defaultlayoutid
            );

            this.sharedDetailForm.controls["layout"].setValue(
              this.recordType.defaultlayoutid
            );

            // this.detailForm.controls.parentobject.patchValue(this.recordType.process);
          }

          this.isLoading = false;
          console.log(this.detailForm.controls["processname"]);
          console.log(this.recordType.processname);
        } else {
          console.log("no data");
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
      }
    );
  }

  getMetalayout() {
    return new Promise((resolve, reject) => {
      console.log("getMetalayout");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          // sortfield: this.sorting.fieldName,
          // sortorder: this.sorting.order,
          metalayout: {
            metaobjectid: this.metaobjectId
            // layouttype: "Page Layout",
            // name: "AcademicSession_New_general",
          }
        }
      };
      console.log("postOption", postOption);

      this.isLoading = true;
      this.dataService.getLayouts(postOption).subscribe(
        (res) => {
          console.log("metalayout list", res);
          if (res !== null && res.success == 1) {
            // this.metalayoutList = res.data.metalayouts;
            this.metalayoutList = res.data.metalayouts.filter(
              (layout) =>
                layout.layouttype === null ||
                layout.layouttype === "Page Layout" ||
                layout.layouttype === "undefined"
            );

            if (res !== null && res.success == 1) {
              var activelayout = res.data.metalayouts;
              var layoutArr = [];
              //just add an empty entry sice this field is optional
              layoutArr.push({ value: "", label: "--None--" });
              for (let i = 0; i < activelayout.length; i++) {
                layoutArr.push({
                  value: activelayout[i].id,
                  label: activelayout[i].name
                });
              }
              this.layout = layoutArr;
              console.log(layoutArr);

              this.isLoading = false;
              resolve(null);
            } else {
              console.log("No process data!");
              this.errorMessage =
                res != null ? res.message : "No process data!";
              this.isError = true;
              this.isLoading = false;
              resolve(null);
            }
            console.log(this.metalayoutList);

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No layouts data!");
            this.errorMessage = res != null ? res.message : "No layouts data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  // save() {
  //   this.isLoading = false;
  //   this.isError = false;
  //   if (this.detailForm.controls["displayname"].value.toString().trim() == "") {
  //     this.showWarning("Recordtype label is mandatory");
  //     return;
  //   }
  //   if (this.detailForm.controls["name"].value.toString().trim() == "") {
  //     this.showWarning("Recordtype name is mandatory");
  //     return;
  //   }

  //   if (this.detailForm.invalid) {
  //     this.errorMessage = "The fields [Label] and [Name] are mandatory.";
  //     return;
  //   }

  //   console.log("mode", this.mode);
  //   if (this.mode.toLowerCase() == "new") {
  //     this.recordTypeId = this.guid.getGUID("recordtype");
  //   }

  //   //prepare data for saving: application
  //   let postOption = {
  //     organizationid: localStorage.getItem("crm_orgid"),
  //     userid: localStorage.getItem("crm_userid"),
  //     username: localStorage.getItem("crm_username"),
  //     useralias: localStorage.getItem("crm_useralias"),
  //     data: {
  //       recordtype: {
  //         metaobjectid: this.metaobjectId,
  //         mode: this.mode,
  //         id: this.recordTypeId,
  //         displayname: this.detailForm.controls["displayname"].value.trim(),
  //         name: this.detailForm.controls["name"].value.trim(),
  //         processname: this.detailForm.controls["processname"].value.trim(),
  //         processid: this.detailForm.controls["processid"].value.trim(),
  //         description: this.detailForm.controls["description"].value.trim(),
  //         active: this.detailForm.controls["active"].value,
  //       },
  //     },
  //   };

  //   console.log("postOption", postOption);

  //   this.isLoading = true;
  //   // this.dataService.upsertRecordType(postOption).subscribe(
  //   //   res => {
  //   //     //alert('****res****' + JSON.stringify(res));
  //   //     console.log(res);
  //   //     if (res.success == 1) {
  //   //       this.showSuccess(res.message);
  //   //       this.isLoading = false;
  //   //       this.router.navigateByUrl('/home/recordtypedetail/' + this.recordTypeId + '/' + this.detailForm.controls['name'].value.trim() +
  //   //         '/' + this.metaobjectId + '/' + this.metaobjectName );
  //   //     }
  //   //     else {
  //   //       console.log("error while saving");
  //   //       this.showError(res.message);
  //   //       this.isLoading = false;
  //   //     }
  //   //   },
  //   //   err => {
  //   //     console.log("Error***:", err);
  //   //     this.showError(err.message);
  //   //     this.isError = true;
  //   //     this.isLoading = false;
  //   //   }
  //   // );
  // }

  // next() {
  //   const formData = this.detailForm.value;
  //   console.log(this.detailForms)
  //   const formDatas = this.commonLayout;

  //   console.log(formData);
  //   console.log(this.commonLayout);

  //   const Name = formData.name;
  //   const labelName = formData.displayname;
  //   const metaobjectid = this.metaobjectId;

  //   // const queryParams = {
  //   //   mode: this.mode,
  //   //   recordTypeId: this.recordTypeId,
  //   //   name: Name,
  //   //   labelname: labelName
  //   // };

  //   // this.RecordtypeEvent.emit(formData);

  //   this.sharedDataService.updateFormData({
  //     formData,
  //     formDatas,
  //     metaobjectid,
  //   });

  //   this.router.navigateByUrl(
  //     "home/recordtype/" +
  //       this.mode +
  //       "/" +
  //       this.metaobjectId +
  //       "/" +
  //       Name +
  //       "/" +
  //       labelName +
  //       "/layout"
  //   );

  //   this.router.navigateByUrl(
  //     "home/record/" +
  //       this.mode +
  //       "/" +
  //       this.metaobjectId +
  //       "/" +
  //       Name +
  //       "/" +
  //       labelName +
  //       "/" +
  //       this.recordTypeId
  //   );
  //   // this.router.navigate(['home/recordtype/layout'], { queryParams: queryParams });
  // }

  onLayoutSelect(profileIndex: number) {
    console.log("Selected layout:", this.profiles[profileIndex].layout);
    console.log("Selected name:", this.profiles[profileIndex].name);
    console.log("Selected id:", this.profiles[profileIndex].id);

    const selectedProfile = {
      profilename: this.profiles[profileIndex].name,
      profileid: this.profiles[profileIndex].id,
      layoutid: this.profiles[profileIndex].layout.value,
      layoutname: this.profiles[profileIndex].layout.label
    };
    const existingIndex = this.layoutProfile.findIndex(
      (change) => change.profileid === this.profiles[profileIndex].id
    );

    if (existingIndex !== -1) {
      // Update the existing entry
      this.layoutProfile[existingIndex] = selectedProfile;
    } else {
      // Add the changes to the array
      this.layoutProfile.push(selectedProfile);
    }
    // this.layoutProfile.push(selectedProfile);

    console.log(this.layoutProfile);
  }
  refreshComponent() {
    const currentUrl = this.router.url;

    this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  save() {
    console.log(this.recordtypeProfile);
    this.isLoading = false;
    this.isError = false;
    if (this.detailForm.controls["displayname"].value.toString().trim() == "") {
      this.showWarning("Recordtype label is mandatory");
      return;
    }
    if (this.detailForm.controls["name"].value.toString().trim() == "") {
      this.showWarning("Recordtype name is mandatory");
      return;
    }

    if (this.detailForm.invalid) {
      this.errorMessage = "The fields [Label] and [Name] are mandatory.";
      return;
    }

    console.log("mode", this.mode);
    if (this.mode.toLowerCase() == "new") {
      this.recordTypeId = this.guid.getGUID("recordtype");
    }

    //prepare data for saving: application
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      useralias: localStorage.getItem("crm_useralias"),
      data: {
        recordtype: {
          metaobjectid: this.metaobjectId,
          metaobjectname: this.metaobjectName,
          mode: this.mode,
          id: this.recordTypeId,
          displayname: this.detailForm.controls["displayname"].value,
          defaultlayoutid: this.sharedDetailForm.controls["layoutid"].value,
          name: this.detailForm.controls["name"].value,
          processname: this.detailForm.controls["processname"].value,
          processid: this.detailForm.controls["processid"].value,
          description: this.detailForm.controls["description"].value,
          mastertype: false,
          active: this.detailForm.controls["active"].value,
          recordtypelayout: [],
          recordtypelayoutweb: [],
          recordtypeprofile: []
        }
      }
    };

    console.log("postOption", postOption);

    var arrRecordtypeLayout = [];
    var arrRecordtypeLayoutWeb = [];

    if (this.isAllProfileSelect == false) {
      for (let recordTypeLayout of this.layoutProfile) {
        if (recordTypeLayout.layoutid !== "") {
          // ✅ Check if makeavailable is true for this profile
          // const profileAllowed = this.recordtypeProfile.find(
          //   (r) =>
          //     r.profileid === recordTypeLayout.profileid &&
          //     r.makeavailable === true
          // );
          // if (!profileAllowed) {
          //   continue; // skip if makeavailable is false or not present
          // }
          if (this.mode.toLowerCase() == "new" && recordTypeLayout !== "") {
            this.recordTypeLayoutId = this.guid.getGUID("metaprofilelayout");
          }
          var recordtypelayouts = {
            // organizationid: localStorage.getItem("crm_orgid"),
            // userid: localStorage.getItem("crm_userid"),
            // username: localStorage.getItem("crm_username"),
            // useralias: localStorage.getItem("crm_useralias"),
            // data: {
            // recordtypelayout: {
            metaobjectid: this.metaobjectId,
            mode: this.mode,
            id: this.recordTypeLayoutId,
            recordtypeid: this.recordTypeId,
            profilename: recordTypeLayout.profilename,
            profileid: recordTypeLayout.profileid,
            userid: null,
            description: "",
            actiontype: "",
            layouttype: "Page Layout",
            active: this.detailForm.controls["active"].value,
            metalayoutid: recordTypeLayout.layoutid,
            metalayoutname: recordTypeLayout.layoutname,
            recordtypename: this.detailForm.controls["name"].value,
            embeddedobject: false,
            parentobjectid: "",
            attributes: {},
            mastertype: false
            // name: this.formData.formData.name,
            // processname: this.formData.formData.processname,
            // processid: this.formData.formData.processid,
            // description: this.formData.formData.description,
            // mastertype: false,
            // active: this.formData.formData.active,
            // },
            // },
          };

          this.metaProfileLayoutWebId = this.guid.getGUID(
            "metaprofilelayoutweb"
          );

          var metaProfileLayoutWebs = {
            id: this.metaProfileLayoutWebId,
            metaobjectid: this.metaobjectId,
            metaobjectname: this.metaobjectName,
            embeddedobject: false,
            parentobjectid: "",
            metalayoutid: recordTypeLayout.layoutid,
            metalayoutname: recordTypeLayout.layoutname,
            recordtypeid: this.recordTypeId,
            recordtypename: this.detailForm.controls["name"].value,
            profileid: recordTypeLayout.profileid,
            profilename: recordTypeLayout.profilename,
            userid: null,
            username: "",
            description: "",
            actiontype: "New",
            active: true,
            layouttype: "Page Layout",
            layoutjsontext: {},
            fieldjsontext: {},
            criteriajsontext: {}
          };

          //push it to array
          arrRecordtypeLayout.push(recordtypelayouts);
          arrRecordtypeLayoutWeb.push(metaProfileLayoutWebs);
        }
      }
    } else {
      for (let profile of this.profiles) {
        // const profileAllowed = this.recordtypeProfile.find(
        //   (r) => r.profileid === profile.id && r.makeavailable === true
        // );
        // if (!profileAllowed) {
        //   continue; // skip if makeavailable is false
        // }
        const layoutId = this.guid.getGUID("metaprofilelayout");

        const recordtypelayouts = {
          metaobjectid: this.metaobjectId,
          mode: this.mode,
          id: layoutId,
          recordtypeid: this.recordTypeId,
          profilename: profile.name,
          profileid: profile.id,
          userid: null,
          description: "",
          actiontype: "",
          layouttype: "Page Layout",
          active: this.detailForm.controls["active"].value,
          metalayoutid: this.oneLayoutId,
          metalayoutname: this.oneLayoutName,
          recordtypename: this.detailForm.controls["name"].value,
          embeddedobject: false,
          parentobjectid: "",
          attributes: {},
          mastertype: false
        };

        const webLayoutId = this.guid.getGUID("metaprofilelayoutweb");

        const metaProfileLayoutWebs = {
          id: webLayoutId,
          metaobjectid: this.metaobjectId,
          metaobjectname: this.metaobjectName,
          embeddedobject: false,
          parentobjectid: "",
          metalayoutid: this.oneLayoutId,
          metalayoutname: this.oneLayoutName,
          recordtypeid: this.recordTypeId,
          recordtypename: this.detailForm.controls["name"].value,
          profileid: profile.id,
          profilename: profile.name,
          userid: null,
          username: "",
          description: "",
          actiontype: "",
          active: true,
          layouttype: "Page Layout",
          layoutjsontext: {},
          fieldjsontext: {},
          criteriajsontext: {}
        };

        arrRecordtypeLayout.push(recordtypelayouts);
        arrRecordtypeLayoutWeb.push(metaProfileLayoutWebs);
      }
    }

    var arrRecordtypeProfile = [];
    for (let recordTypeProfile of this.recordtypeProfile) {
      if (this.mode.toLowerCase() == "new") {
        this.recordTypeProfileId = this.guid.getGUID("recordtypeprofile");
      }
      var recordtypeprofiles = {
        id: this.recordTypeProfileId,
        recordtypeid: this.recordTypeId,
        profilename: recordTypeProfile.profilename,
        profileid: recordTypeProfile.profileid,
        isdefault: recordTypeProfile.makedefault,
        isavailable: recordTypeProfile.makeavailable
      };

      //push it to array
      arrRecordtypeProfile.push(recordtypeprofiles);
    }

    // console.log("postOption1", postOption1);
    postOption.data.recordtype.recordtypelayout = arrRecordtypeLayout;
    postOption.data.recordtype.recordtypelayoutweb = arrRecordtypeLayoutWeb;
    postOption.data.recordtype.recordtypeprofile = arrRecordtypeProfile;
    const domain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.domain`
    );
    // let publish = {
    //   // topic: "scherp.admin.basicaccesspermission.created",
    //   topic: `${domain}.admin.basicaccesspermission.created`, // ✅ dynamic

    //   group_id: "create_basicaccesspermission",
    //   message: [
    //     {
    //       context: {
    //         organizationid: localStorage.getItem("crm_orgid")
    //       },
    //       user: {
    //         org_code: localStorage.getItem(
    //           `${localStorage.getItem("crm_orgid")}.subdomain`
    //         )
    //       },
    //       domain: domain,
    //       // domain: localStorage.getItem(
    //       //   `${localStorage.getItem("crm_orgid")}.domain`
    //       // ),
    //       subdomain: localStorage.getItem(
    //         `${localStorage.getItem("crm_orgid")}.subdomain`
    //       )

    //       // action: {
    //       //   modulename: metaobjectName,
    //       // },
    //     }
    //   ]
    // };

    let publish = {
      // topic: "scherp.admin.basicaccesspermission.created",
      topic: `${domain}.admin.basicaccesspermission.created`, // ✅ dynamic
      group_id: "create_basicaccesspermission",
      message: [
        {
          context: {
            organizationid: localStorage.getItem("crm_orgid")
          },
          user: {
            org_code: localStorage.getItem(
              `${localStorage.getItem("crm_orgid")}.subdomain`
            ),
            app_name: domain
          },

          domain: localStorage.getItem(
            `${localStorage.getItem("crm_orgid")}.domain`
          ),
          subdomain: localStorage.getItem(
            `${localStorage.getItem("crm_orgid")}.subdomain`
          ),

          action: {
            modulename: this.metaobjectName
          }
        }
      ],
      relative_url: "api/v1/turbo/c/metaobject"
    };
    const orgId = localStorage.getItem("crm_orgid");

    const event_id = eventId("Metadata", this.metaobjectName, "create");
    const requestid = getRequestID();
    const subdomain = localStorage.getItem(`${orgId}.subdomain`);
    // let publish = {
    //   topic: `${domain}.admin.basicaccesspermission.created`,
    //   group_id: "create_basicaccesspermission",

    //   message: [
    //     {
    //       current_context: {},

    //       context: {
    //         organizationid: orgId
    //       },

    //       user: {
    //         user_name: localStorage.getItem("crm_loginid"),

    //         _id: localStorage.getItem("crm_userid"),

    //         name: localStorage.getItem("crm_username"),

    //         app_name: domain
    //       },

    //       domain: domain,

    //       subdomain: subdomain,

    //       action: {
    //         modulename: this.metaobjectName,
    //         event_id: event_id
    //       },

    //       // relative_url: "api/v1/turbo/c/metaobject",

    //       query: {}
    //     }
    //   ],
    //   relative_url: "api/v1/turbo/c/metaobject",

    //   request_id: requestid
    // };
    console.log("publish@@@@@@@@@@@@", publish);
    console.log(postOption);
    this.isLoading = true;
    this.dataService.upsertRecordType(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.showSuccess(res.message);
          this.isLoading = false;

          if (this.mode.toLowerCase() === "new") {
            const payload = {
              topic: `${domain}.admin.recordtype.created`,
              group_id: "admin_sync",
              message: [
                {
                  context: {
                    organizationid: localStorage.getItem("crm_orgid")
                  },
                  user: {
                    org_code: localStorage.getItem(
                      `${localStorage.getItem("crm_orgid")}.subdomain`
                    ),
                    app_name: domain
                  },
                  domain: localStorage.getItem(
                    `${localStorage.getItem("crm_orgid")}.domain`
                  ),
                  data: {
                    id: this.recordTypeId
                  },
                  action: {
                    modulename: this.metaobjectName
                  },
                  request_id: requestid
                }
              ]
            };

            this.dataService.outboxeventPublish(payload).subscribe();
          }

          this.router.navigateByUrl(
            "/home/metaobjectdetail/" +
              this.metaobjectId +
              "/" +
              this.metaobjectName
          );

          this.dataService.outboxeventPublish(publish).subscribe();
        } else {
          console.log("error while saving");
          this.showError(res.message);
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.showError(err.message);
        this.isError = true;
        this.isLoading = false;
      }
    );
  }
}
